import { LocationUtils } from '@ctct/rise-utils';
import { useTranslations } from 'next-intl';
import { type ComponentProps } from 'react';

import { type InputOpts } from '../../../types';
import { ComboboxInput } from '../../inputs-core';

const StateCodeCombobox = ({
  formKey,
  registerOpts,
  buttonText: selectedValue,
  ...selectProps
}: InputOpts & Omit<ComponentProps<typeof ComboboxInput>, 'items'>) => {
  const t = useTranslations('UiForm');
  let comboboxItems = LocationUtils.states.map((state) => ({
    label: state.name,
    value: state.abbreviation,
  }));

  const selectedItem = comboboxItems.find(
    (item) => item.value?.toLowerCase() === selectedValue?.toLowerCase()
  );
  const filteredItems = selectedItem
    ? comboboxItems.filter((item) => item.value !== selectedItem.value)
    : comboboxItems;

  comboboxItems = selectedItem ? [selectedItem, ...filteredItems] : comboboxItems;

  return (
    <ComboboxInput
      formKey={formKey}
      registerOpts={registerOpts}
      placeholderText={t('shared.state.searchPlaceholder')}
      items={comboboxItems}
      buttonText={selectedValue}
      {...selectProps}
    />
  );
};

export { StateCodeCombobox };
